// removed by extract-text-webpack-plugin
module.exports = {"close-button":"_3Us0qTlG0GGm8Wyrqip2wM"};


//////////////////
// WEBPACK FOOTER
// ./src/features/CloseButton/closebutton.module.styl
// module id = 117
// module chunks = 90860694354714 110109448666130 259173521737895